import { loadingBarReducer as loadingBar } from 'react-redux-loading-bar';

import locale from './locale';
import authentication from './authentication';
import applicationProfile from './application-profile';

import administration from 'app/modules/administration/administration.reducer';
import userManagement from 'app/modules/administration/user-management/user-management.reducer';
import register from 'app/modules/account/register/register.reducer';
import activate from 'app/modules/account/activate/activate.reducer';
import password from 'app/modules/account/password/password.reducer';
import settings from 'app/modules/account/settings/settings.reducer';
import passwordReset from 'app/modules/account/password-reset/password-reset.reducer';
import commodity from 'app/entities/commodity/commodity.reducer';
import customer from 'app/entities/customer/customer.reducer';
import quotation from 'app/entities/quotation/quotation.reducer';
import bank from 'app/entities/bank/bank.reducer';
import branch from 'app/entities/branch/branch.reducer';
import currencyRates from 'app/entities/currency-rates/currency-rates.reducer';
import comexSettings from 'app/entities/comex-settings/comex-settings.reducer';
import notificationTemplate from 'app/entities/notification-template/notification-template.reducer';
import notificationRecord from 'app/entities/notification-record/notification-record.reducer';
import bursaAPIBidCert from 'app/entities/bursa-api-bid-cert/bursa-api-bid-cert.reducer';
import bursaAPIOtcCert from 'app/entities/bursa-api-otc-cert/bursa-api-otc-cert.reducer';
import bursaAPIStbCert from 'app/entities/bursa-api-stb-cert/bursa-api-stb-cert.reducer';
import purchaseCancellation from 'app/entities/purchase-cancellation/purchase-cancellation.reducer';
import bursaAPIOrder from 'app/entities/bursa-api-order/bursa-api-order.reducer';
import bursaAPIOrderResult from 'app/entities/bursa-api-order-result/bursa-api-order-result.reducer';
import bursaAPIEndPoints from 'app/entities/bursa-api-end-points/bursa-api-end-points.reducer';
import currencyIndex from 'app/entities/currency-index/currency-index.reducer';
import currencyPairsLog from 'app/entities/currency-pairs-log/currency-pairs-log.reducer';
import comexBankFee from 'app/entities/comex-bank-fee/comex-bank-fee.reducer';
import comexBankFeeLog from 'app/entities/comex-bank-fee-log/comex-bank-fee-log.reducer';
import commodityLog from 'app/entities/commodity-log/commodity-log.reducer';
import purchaseOrder from 'app/entities/purchase-order/purchase-order.reducer';
import notifyCancellationEmails from 'app/entities/notify-cancellation-emails/notify-cancellation-emails.reducer';
import authToken from 'app/entities/auth-token/auth-token.reducer';
import banklog from 'app/entities/banklog/banklog.reducer';
import commissionLog from 'app/entities/commission-log/commission-log.reducer';
import bulkTransaction from 'app/entities/bulk-transaction/bulk-transaction.reducer';
import bulkTransactionRecord from 'app/entities/bulk-transaction-record/bulk-transaction-record.reducer';
import bankApiSetting from 'app/entities/bank-api-setting/bank-api-setting.reducer';
import iban from 'app/entities/quotation/iban-reducer';
import quotationType from 'app/entities/quotation/quotation-type.reducer';
import file from 'app/entities/file/file.reducer';
import S3File from 'app/entities/file/S3File.reducer';
import bookingConfirmation from 'app/entities/booking-confirmation/booking-confirmation.reducer';
import bookingConfirmationEmail from 'app/entities/booking-confirmation-email/booking-confirmation-email.reducer';
import partner from 'app/entities/partner/partner.reducer';
import bankAgreementDateLog from 'app/entities/bank-agreement-date-log/bank-agreement-date-log.reducer';
import rebateDocumentEmail from 'app/entities/rebate-document-email/rebate-document-email.reducer';
import transferOtp from 'app/modules/transfer-otp/transfer-otp.reducer';
import rebateSetting from 'app/entities/rebate-setting/rebate-setting.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const rootReducer = {
  authentication,
  locale,
  applicationProfile,
  administration,
  userManagement,
  register,
  activate,
  passwordReset,
  password,
  settings,
  commodity,
  customer,
  quotation,
  bank,
  branch,
  currencyRates,
  comexSettings,
  notificationTemplate,
  notificationRecord,
  bursaAPIBidCert,
  bursaAPIOtcCert,
  bursaAPIStbCert,
  purchaseCancellation,
  bursaAPIOrder,
  bursaAPIOrderResult,
  bursaAPIEndPoints,
  currencyIndex,
  currencyPairsLog,
  comexBankFee,
  comexBankFeeLog,
  commodityLog,
  purchaseOrder,
  notifyCancellationEmails,
  authToken,
  banklog,
  commissionLog,
  bulkTransaction,
  bulkTransactionRecord,
  bankApiSetting,
  iban,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
  loadingBar,
  quotationType,
  file,
  S3File,
  bookingConfirmation,
  bookingConfirmationEmail,
  partner,
  bankAgreementDateLog,
  rebateDocumentEmail,
  transferOtp,
  rebateSetting,
};

export default rootReducer;
